import { useEffect, useRef, useState } from "react";
import socketIOClient from "socket.io-client";
import $ from 'jquery';

const SOCKET_SERVER_URL = "http://13.124.5.10:4000";

const ADD_COMMENT_EVENT = "addComment";
const DELETE_COMMENT_EVENT = "deleteComment";
const ADD_REPLY_EVENT = "addReply";
const DELETE_REPLY_EVENT = "deleteReply";
const CHANGE_HASHTAG_VOTE_EVENT="changeHashtagVote";
const ADD_HASHTAG_EVENT="addHashtag";
const CHANGE_UPDOWN_VOTE_EVENT="changeUpDownVote";

const useReaction = (postNo, group) => {
  const [comments, setComments] = useState([]); // Sent and received messages
  const socketRef = useRef();

  const getComments = () =>{
    const username = localStorage.getItem('username');
    const token = localStorage.getItem('token');
    $.ajax({
      url:'../../api/get-comments/',
      method: 'GET',
      data: {'post_no': postNo, 'username': username, 'token': token},
      success: function(res){
        setComments(res.comments);
      },
      error: function(err){
        console.log('error!')
      },
    })
  }
  console.log('useReaction called')

  useEffect(() => {
      getComments();
    console.log("Keep calling")
    // Creates a WebSocket connection
    socketRef.current = socketIOClient(SOCKET_SERVER_URL, {
      query: {
           postNo: postNo,
           group: group
     },
    });

    socketRef.current.on(ADD_COMMENT_EVENT, (comment) => {
        setComments((comments) => [...comments, comment.newcomment]);
        });

    socketRef.current.on(DELETE_COMMENT_EVENT, (deleted) => {
        setComments((comments) => comments.filter(item=>item.id!==deleted.id));
        });

    socketRef.current.on(ADD_REPLY_EVENT, (reply) => {
        setComments((comments) => {
            let curcomment=comments.find(comment => comment.id===reply.comment_id);
            if(curcomment!==undefined){
                curcomment.replies= [...curcomment.replies, reply.newreply];
            }
            return [...comments]})
        });

    socketRef.current.on(DELETE_REPLY_EVENT, (reply) => {
        console.log("deleteReplyheard", reply)
        setComments((comments) => {
            let curcomment=comments.find(comment => comment.id===reply.comment_id);
            if(curcomment!==undefined){
                curcomment.replies=curcomment.replies.filter(item=>item.id!==reply.id);
            }
            return [...comments]})
        });
    
    socketRef.current.on(CHANGE_HASHTAG_VOTE_EVENT, (data) => {
      const receiver=localStorage.getItem('username')
        setComments((comments)=>{
          let curcomment=comments.find(comment => comment.id===data.comment_id);
          if(data.direction==='up'){
            let curhashtag=curcomment.hashtags.pos.find(hashtag => hashtag.id===data.hashtag_id);
            if(data.is_cancel){
              curhashtag.votes=curhashtag.votes-1;
              if(curhashtag.votes<=0){
                curcomment.hashtags.pos=curcomment.hashtags.pos.filter(hashtag => hashtag.id !== data.hashtag_id);
              }else{
              if(receiver===data.sender){
                curhashtag.voted=false;
              }}
            }else{
              curhashtag.votes=curhashtag.votes+1;
              if(receiver===data.sender){
                curhashtag.voted=true;
              }
            }
            return [...comments]
          }else{
            let curhashtag=curcomment.hashtags.neg.find(hashtag => hashtag.id===data.hashtag_id);
            if(data.is_cancel){
              curhashtag.votes=curhashtag.votes-1;
              if(curhashtag.votes<=0){
                curcomment.hashtags.neg=curcomment.hashtags.neg.filter(hashtag => hashtag.id !== data.hashtag_id);
              }else{
              if(receiver===data.sender){
                curhashtag.voted=false;
              }}
            }else{
              curhashtag.votes=curhashtag.votes+1;
              if(receiver===data.sender){
                curhashtag.voted=true;
              }
            }
            return [...comments]
          }})
      });

      socketRef.current.on(ADD_HASHTAG_EVENT, (data) => {
        console.log('add hashtag heard')
        const receiver=localStorage.getItem('username')
        console.log(data)
        setComments((comments)=>{
            let curcomment=comments.find(comment => comment.id===data.comment_id);
            if(data.direction==='up'){
              const newhashtag=data.newhashtag
              if(receiver!==data.sender){
                newhashtag.voted=false;
              }
              curcomment.hashtags.pos = [...curcomment.hashtags.pos, newhashtag]
              return [...comments]
            }else{
              const newhashtag=data.newhashtag
              if(receiver!==data.sender){
                newhashtag.voted=false;
              }
              curcomment.hashtags.neg = [...curcomment.hashtags.neg, newhashtag]
              return [...comments]
            }})
        });

        socketRef.current.on(CHANGE_UPDOWN_VOTE_EVENT, (data) => {
          const receiver=localStorage.getItem('username')
            setComments((comments)=>{
              let curcomment=comments.find(comment => comment.id===data.comment_id);
              if(data.direction==='up'){
                let curvote=curcomment.updownvotes.upvotes;
                if(data.is_cancel){
                  curvote.count=Math.max(curvote.count-1,0);
                  if(receiver===data.sender){
                    curvote.voted=false;
                  }
                }else{
                  curvote.count=curvote.count+1;
                  if(receiver===data.sender){
                    curvote.voted=true;
                  }
                }
                return [...comments]
              }else{
                let curvote=curcomment.updownvotes.downvotes;
                if(data.is_cancel){
                  curvote.count=Math.max(curvote.count-1,0);
                  if(receiver===data.sender){
                    curvote.voted=false;
                  }
                }else{
                  curvote.count=curvote.count+1;
                  if(receiver===data.sender){
                    curvote.voted=true;
                  }
                }
                return [...comments]
              }
              })
          });
    
    return () => {
        socketRef.current.disconnect();
        };
    }, );



      
 const addComment = (group, username, input) => {
    $.ajax({
        url:'../../api/add-comment/',
        method: 'POST',
        data: {'post_no': postNo, 'group': group, 'username': username, 'text': input},
        success: function(res){
            socketRef.current.emit(ADD_COMMENT_EVENT, {
                newcomment: res.comment
            });
    },
        error: function(err){
          console.log('error!')
        },
      })
  };

  const deleteComment = (username, comment_id) => {
    $.ajax({
        url:'../../api/delete-comment/',
        method: 'POST',
        data: {'comment_id': comment_id, 'username': username},
        success: function(){
            socketRef.current.emit(DELETE_COMMENT_EVENT, {
                id: comment_id
            });
     },
        error: function(err){
          console.log('error!')
        },
      })
  };

  const addReply = (group, username, comment_id, replyinput) =>{
    $.ajax({
        url:'../../api/add-reply/',
        method: 'POST',
        data: {'comment_id': comment_id, 'group': group, 'username': username, 'text': replyinput},
        success: function(res){
            socketRef.current.emit(ADD_REPLY_EVENT, {
                comment_id: comment_id,
                newreply: res.reply
            });
    },
        error: function(err){
          console.log('error!')
        },
      })
  };
  const deleteReply = (group, username,comment_id, reply_id) =>{
    $.ajax({
        url:'../../api/delete-reply/',
        method: 'POST',
        data: {'reply_id': reply_id, 'group': group, 'username': username},
        success: function(){
            socketRef.current.emit(DELETE_REPLY_EVENT, {
                comment_id: comment_id, 
                id: reply_id
            })
        },
        error: function(err){
          console.log('error!')
        },
      })
  };

  const changeHashtagVote = (group, username,comment_id, direction, hashtag_id, voted) =>{
    $.ajax({
      url:'../../binarytext/change-vote/',
      method: 'POST',
      data: {'hashtag_id': hashtag_id, 'group':group,'username': username, 'current':voted},
      success: function(res){
        socketRef.current.emit(CHANGE_HASHTAG_VOTE_EVENT, {
          comment_id: comment_id, 
          direction: direction, 
          hashtag_id: hashtag_id,
          sender: username, 
          is_cancel: voted
      })
      },
      error: function(err){
          console.log('error!')
      },
    })
  };

  const addHashtag = (group, username,comment_id, direction, label) =>{
    console.log("emitted")
    $.ajax({
      url:'../../binarytext/add-hashtag/',
      method: 'POST',
      data: {'comment_id':comment_id, 'group': group, 'username': username,'label': label, 'direction':direction},
      success: function(res){
        socketRef.current.emit(ADD_HASHTAG_EVENT, {
          newhashtag: res.hashtag,
          comment_id: comment_id, 
          direction: direction, 
          sender: username, 
      })
      },
      error: function(err){
          console.log('error!')
      },
    })
  };

  const changeUpDownVote = (username,comment_id, direction, voted) =>{
    $.ajax({
      url:'../../binary/change-vote/',
      method: 'POST',
      data: {'comment_id': comment_id, 'username': username, 'direction': direction, 'current': voted},
      success: function(res){
        socketRef.current.emit(CHANGE_UPDOWN_VOTE_EVENT, {
          comment_id: comment_id, 
          direction: direction, 
          sender: username, 
          is_cancel: voted
      })
      },
      error: function(err){
        console.log('error!')
      },
    })
  };

  return { comments, addComment, deleteComment, addReply, deleteReply, changeHashtagVote, addHashtag, changeUpDownVote};
};

export default useReaction;